import React from 'react';

function PressureUlcers() {
  return (
    <div>
      <h2>Pressure Ulcers Treatment</h2>
      <p>Our team specializes in treating and preventing pressure ulcers...</p>
    </div>
  );
}

export default PressureUlcers;
